var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8125 22.6672C20.1262 22.6672 22.8125 19.9809 22.8125 16.6672C22.8125 13.3535 20.1262 10.6672 16.8125 10.6672C13.4988 10.6672 10.8125 13.3535 10.8125 16.6672C10.8125 19.9809 13.4988 22.6672 16.8125 22.6672Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4884 10.7483C25.7841 11.1825 26.0468 11.6384 26.2743 12.112L29.5176 13.9125C29.9126 15.7268 29.914 17.6048 29.5216 19.4197L26.2765 21.2211C26.0483 21.6944 25.7848 22.1498 25.4884 22.5836L25.5508 26.2926C24.1771 27.5419 22.5514 28.482 20.7834 29.0496L17.6008 27.14C17.0769 27.179 16.5507 27.1786 16.0268 27.1388L12.8459 29.0473C11.0772 28.4823 9.45013 27.5445 8.07458 26.2972L8.13705 22.5861C7.84129 22.1519 7.57857 21.696 7.35112 21.2224L4.10784 19.422C3.7128 17.6076 3.71144 15.7297 4.10386 13.9147L7.34894 12.1133C7.57714 11.6401 7.84058 11.1846 8.13702 10.7508L8.07459 7.04184C9.44834 5.79256 11.074 4.8524 12.842 4.28479L16.0246 6.19441C16.5486 6.1554 17.0747 6.15581 17.5986 6.19565L20.7795 4.28709C22.5483 4.85215 24.1753 5.78995 25.5508 7.03725L25.4884 10.7483Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearSix);
export default __webpack_public_path__ + "static/media/GearSix.76f7396b7a93b1ee0d37410710331e42.svg";
export { ForwardRef as ReactComponent };